<ng-container *transloco="let tr; prefix: 'webkassaCashboxes'; scope: 'webkassa-cashboxes'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
      <nz-page-header-subtitle>{{tr('subTitle')}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="org-auths/list" nz-button nzType="primary">
          <i nz-icon nzType="cloud-server" nzTheme="outline"></i> {{tr('button.auth')}}
        </a>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <hx-org-select [(ngModel)]="filter.orgId" (ngModelChange)="applyFilters()"></hx-org-select>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="name" [nzSortOrder]="columnSortOrderMap.get('name') || null" [nzSortFn]="true"
          [nzSortPriority]="1">{{tr('column.name')}}</th>
      <th nzColumnKey="uniqueNumber">{{tr('column.uniqueNumber')}}</th>
      <th nzColumnKey="description">{{tr('column.description')}}</th>
      <th nzColumnKey="status">{{tr('column.status')}}</th>
      <th nzColumnKey="org-title" [nzSortOrder]="columnSortOrderMap.get('org-title') || null" [nzSortFn]="true"
          [nzSortPriority]="1">{{tr('column.organization')}}</th>
      <th nzColumnKey="store">{{tr('column.store')}}</th>
      <th nzColumnKey="onlineCashboxNumber">{{tr('column.onlineCashboxNumber')}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of listTable.data">
      <td>
        <i nz-icon [nzType]="data.enabled ? 'check-circle' : 'minus-circle'"
             [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
        {{ data.name }}
      </td>
      <td>{{ data.uniqueNumber }}</td>
      <td>{{ data.description }}</td>
      <td>{{ data.status }}</td>
      <td>{{ data.organization.title | uiLabel }}</td>
      <td>{{ data.store?.title | uiLabel }}</td>
      <td>{{ data.onlineCashboxUniqueNumber }}</td>
      <td>
        <nz-button-group>
          <button [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
